import React from 'react';
import styles from './Spinner.module.scss';

const Spinner = () => <div className={styles.loader}>Loading...</div>;

export default Spinner;
